export default {
    when() {
      return document.querySelectorAll('.accordion-header-mobile').length > 0;
    },
  
    mounted() {
      const accordionHeader = document.querySelectorAll('.accordion-header-mobile');
      accordionHeader.forEach((header) => {
        header.addEventListener(
          'click',
          function () {
            let accordionContent = header.parentElement.querySelector(
              '.accordion-content-mobile'
            );
            let accordionIcon = header.querySelector('.accordion-icon-mobile');
            let accordionMaxHeight = accordionContent.style.maxHeight;
            // Condition handling
            if (accordionMaxHeight == '0px' || accordionMaxHeight.length == 0) {
              accordionContent.style.maxHeight = `${
                accordionContent.scrollHeight + 32
              }px`;
              accordionContent.classList.add('animate-slide-in-top');
  
              accordionIcon.classList.add('animate-rotate-180-bw');
              setTimeout(() => {
                header
                  .querySelector('.accordion-icon-mobile')
                  .classList.remove('animate-rotate-180-bw');
                  header
                .querySelector('.accordion-icon-mobile')
                .classList.add('rotate-180');
                // accordionIcon
                //   .querySelector('.accordion-icon-mobile')
                //   .classList.add('fa-arrow-up');
                // accordionIcon.classList.remove('animate-rotate-180-bw');
              }, 400);
            } else {
              accordionContent.style.maxHeight = `0px`;
              accordionContent.classList.remove('animate-slide-in-top');
              
              accordionIcon.classList.add('animate-rotate-180-cw');
              setTimeout(() => {
                header
                .querySelector('.accordion-icon-mobile')
                .classList.remove('rotate-180');
                header
                .querySelector('.accordion-icon-mobile')
                .classList.remove('animate-rotate-180-cw');
                
              }, 400);
            }
          },
          { passive: true }
        );
      });
    },
  };
  